import React from 'react';
import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { get } from 'lodash';

import Button from 'components/ContentfulFields/Button';
import styles from './nonDeliveryOption.scss';

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
      const id = get(node, 'data.target.sys.contentType.sys.id');

      switch (id) {
        case 'button':
          return (
            <Button
              className={styles.btn}
              document={node.data.target}
              to={node.data.target.fields.link}
            >
              {children}
            </Button>
          );
        default:
          return null;
      }
    },
  },
};

const NonDeliveryOption = ({ option }) => {
  const { carouselImage, description, title } = option;

  return (
    <div className={styles.nonDeliveryOptionWrapper}>
      <div className={styles.nonDeliveryOption}>
        <div className={styles.content}>
          <h2 className={styles.title}>{title}</h2>
          {documentToReactComponents(description, options)}
        </div>
        <picture className={styles.imgWrapper}>
          <img
            src={`${carouselImage.fields.file.url}?fm=webp`}
            alt={carouselImage.fields.description || ''}
            aria-hidden="true"
          />
        </picture>
      </div>
    </div>
  );
};

NonDeliveryOption.propTypes = {
  option: PropTypes.object.isRequired,
};

export default NonDeliveryOption;
